export enum Type {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    body = 'body',
    caption = 'caption',
    tiny = 'tiny',
}

export enum TagName {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    p = 'p',
    span = 'span',
    li = 'li',
    b = 'b',
    pre = 'pre',
    div = 'div',
    em = 'em',
}

export interface Props {
    tagName?: TagName;
    type?: Type | null;
    className?: string;
    isBold?: boolean;
    color?: Color | null;
    attrs?: {
        [key: string]: string | number;
    };
    el?: HTMLElement | null;
    style?: string | null;
    slot?: string | null;
    title?: string | null;
}

export enum Color {
    Primary = 'primary',
    Secondary = 'secondary',
    Brand = 'brand',
    Disabled = 'disabled',
    Invert = 'invert',
    Unset = 'unset',
    White = 'white',
}
